import { Form, Row } from 'antd'
import styled from 'styled-components'
import { InputDiagnosis } from './InputDiagnosis'
import { BaseQuestionProps } from '../types'
import QuestionContainer from '../QuestionContainer'

export type OtherDiagnosisQuestionProps = Omit<BaseQuestionProps, 'layout'>

const Container = styled.div`
  margin: 16px 0;
`

function OtherDiagnosesQuestion({
  field,
  formFieldName,
  required
}: OtherDiagnosisQuestionProps): JSX.Element {
  return (
    <QuestionContainer linkId={field.linkId}>
      <Container>
        <Form.List name={formFieldName}>
          {(fields) => (
            <>
              {fields.map((field) => (
                <Row key={field.key} style={{ gap: '16px', marginBottom: '16px' }}>
                  <InputDiagnosis
                    fieldName={field.name}
                    label="Other Diagnosis"
                    required={required}
                  />
                </Row>
              ))}
            </>
          )}
        </Form.List>
      </Container>
    </QuestionContainer>
  )
}

export default OtherDiagnosesQuestion
